// Permisos RBAC de Promos venta. `list` abre la pantalla; `codeList` abre la pestaña de códigos y
// cupones. Crear, editar, anular y leer el historial son aparte.

/** Van como `string`: `PermissionKey`, generado del OpenAPI, no expone claves de dominio. */
export const PROMOTIONS_PERMISSIONS = {
    list: 'retail.promotion.list',
    create: 'retail.promotion.create',
    update: 'retail.promotion.update',
    readLog: 'retail.promotion.log.read',
    codeList: 'retail.promotion.code.list',
    codeCreate: 'retail.promotion.code.create',
    codeVoid: 'retail.promotion.code.void',
} as const;
